import React from "react";
import PeopleManager from "@/components/app/PeopleManager";
export default function Students() { return <PeopleManager kind="student" />; }
